import { http } from './http';
import { apiHelper } from 'shared';

const controllerName = 'tobacco-products';

class TobaccoProducts {
  async getUsingQueryFilter(queryFilter) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ name: queryFilter });

    const response = await http.get(`/${controllerName}${queryString}`);
    const items = response.data && response.data.items;

    return items;
  }

  get(paging, sorting, filters) {
    let queryString = '';
    queryString = apiHelper.composeQueryString({ ...paging, ...sorting, ...filters });

    return http.get(`/${controllerName}/${queryString}`);
  }

  getById(id) {
    return http.get(`/${controllerName}/${id}`);
  }

  create(product) {
    return http.post(`/${controllerName}`, product);
  }

  delete(id) {
    return http.delete(`/${controllerName}/${id}`);
  }

  update(id, product) {
    return http.put(`/${controllerName}/${id}`, product);
  }
}

export const tobaccoProducts = new TobaccoProducts();
